import React from "react";
import { Box, Typography } from "@mui/material";
import PaynamicsImg1 from "../../assets/paynamics/PaynamicsImg1";

const PaynamicsSuccessPage: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "20px",
      }}
    >
      <PaynamicsImg1 />
      <Box
        sx={{
          width: "75%",
          textAlign: "center",
          marginTop: "15px",
          marginX: "auto",
        }}
      >
        <Typography variant="h4">Finishing your Transaction</Typography>
        <br />
        <Typography variant="subtitle1">
          Your payment is being processed. To avoid issues, do not repeat the
          transaction. If your transaction does not proceed successfully, email{" "}
          <a href="mailto:cxc@malayan.com">cxc@malayan.com</a>.
        </Typography>
      </Box>
    </Box>
  );
};

export default PaynamicsSuccessPage;
